export default {
	//...en,
	langname: "English",
	language: "language",
	homepage: "Home",
	profile: "Profile",
	log: "log",

	boolean: "boolean",
	int: "int",
	float: "float",
	datetime: "datetime",
	string: "string",

	commonAttributes: "common attributes",
	type: "type",
	types: "types",
	name: "name",
	namePersonOrganisation: "name",
	number: "number",
	date: "date",
	from: "from",
	to: "to",
	yes: "yes",
	not: "not",
	error: "error",

	commonActions: "common actions",
	actions: "actions",
	enter: "enter",
	entry: "entry",
	exit: "exit",
	ok: "ok",
	cancel: "cancel",
	confirm: "confirm",
	agree: "agree",
	disagree: "disagree",
	add: "add",
	remove: "remove",
	preview: "preview",
	clear: "clear",
	new: "new",
	edit: "edit",
	create: "create",
	update: "update",
	delete: "delete",
	search: "search",
	moveup: "move up",
	movedown: "move down",
	moveleft: "move left",
	moveright: "move right",
	login: "login",
	signin: "Sign In",
	signup: "signup",
	save: "save",
	open: "open",
	close: "close",
	cut: "cut",
	copy: "copy",
	duplicate: "duplicate",
	paste: "paste",
	refresh: "refresh",
	export: "export",
	import: "import",
	dict: "dictionary",
	authorization: "authorization",
	registration: "registration",
	createaccount: "Create Account",
	password: "password",
	passwordold: "password old",
	passwordnew: "password new",
	passwordconfirm: "password confirm",
	passwordchange: "password change",
	passwordreset: "password reset",
	passwordrecovery: "password recovery",
	passwordforgot: "Forgot password?",
	donthaveaccount: "don't you have account?",
	orderconnection: "Order connection",
	expand: "expand",
	collapse: "collapse",
	
	// Objects
	main: "main",
	account:"account",
	accounts:"accounts",
	bot:"bot",
	bots:"bots",
	command:"command",
	commands:"commands",
	users: "users",
	user: "user",
	roles: "roles",
	role: "role",
	scenarium: "scenarium",
	scenariums: "scenarium",
	chat: "chat",
	chats: "chats",
	talk: "talk",
	talks: "talks",
	gallery: "gallery",
	message: "message",
	messages: "messages",
	request: "request",
	requests: "requests",
	respond: "respond",
	responds: "responds",
	menu: "menu",
	menutype: "menutype",
	menutypes: "menutypes",
	func: "function",
	funcs: "functions",
	funcparam: "function's parameter",
	funcparams: "function's parameters",
	functype: "functype",
	functypes: "functypes",
	function: "function",
	functions: "functions",
	param: "parameter",
	params: "parameters",
	parameter: "parameter",
	parameters: "parameters",
	method: "method",
	methods: "methods",
	methodparam: "method's parameter",
	methodparams: "method's parameters",
	property: "property",
	properties: "properties",
	SettlementNotice: "settlement notice",
	SettlementNotices: "settlement notices",
	ChatCategory: "chat's category",
	ChatCategories: "chat's categories",

	token: "token",
	text: "text",
	photo: "photo",
	audio: "audio",
	sticker: "sticker",
	video: "video",
	animation: "animation",
	voice: "voice",
	location: "location",
	venue: "venue",
	media: "media",

	caption: "caption",
	title: "title",
	firstName: "first name",
	middleName: "middle name",
	lastName: "last name",
	phoneNumber: "phone number",
	disableNotification: "disable notification",
	onetime: "one time",
	resize: "resize",
	hidden: "hidden",
	defaltvalue: "defalt value",
	
	//Keyboard
	keyboard: "keyboard",
	keyboards: "keyboards",
	keyboardtype: "keyboard's type",
	keyboardtypes: "keyboard types",
	keyboardbutton: "keyboard's button",
	keyboardbuttons: "keyboard buttons",
	tableAdd: "add table",
	tableRemove: "remove table",
	tableRefresh: "refresh table",
	tableRowAddBefore: "add table row before",
	tableRowAddAfter: "add table row after",
	tableRowRemove: "remove table row",
	tableColAddBefore: "add table column before",
	tableColAddAfter: "add table column after",
	tableColRemove: "remove table column",
	tableColMoveLeft: "move table column left",
	tableColMoveRight: "move table column right",
	tableRowMoveUp: "move table row up",
	tableRowMoveDown: "move table row down",
	InlineKeyboardMarkup: "Inline Keyboard Markup",
	ReplyKeyboardMarkup: "Reply Keyboard Markup",
	ReplyKeyboardRemove: "Reply Keyboard Remove",
	buttonsproperties: "button's properties",

	//Sentences
	"Are you sure you want to delete this record?": "Are you sure you want to delete this record?",
   
	row: "row",
	rows: "rows",
	column: "column",
	columns: "columns",

	//homepage.banner
	cameraoff: "На вашому пристрої доступ до камери заблоковано. В такому режимі ви можете перевіряти поліси, шляхом введення вручну номер полісу або цифри зі штрих-коду.",
	
	stopscan: "stop scan",
	startscan: "start scan",

	settings: "settings",
	frame: "frame",
	laser: "laser",
	sound: "sound",
	soundeditor: "sound editor",
	volume: "volume",
	frequency: "frequency",
	duration: "duration",
	beeps: {
		scan: "scan",
		success: "success",
		failure: "failure",
		error: "error",
	},
	
	//Attributes
	id: "id",
	code: "code",
	username: "id",
	description: "description",
	datecreate: "datecreate",
	datesign: "date sign",
	datebegin: "date begin",
	dateend: "date end",
	dateclose: "date close",
	pib: "name and surname",
	telephone: "telephone",
	email: "email",
	icon: "icon",
	regexpression: "regexpression",
	ordinal: "ordinal",
	datatype: "datatype",
	datatypes: "datatypes",
	button: "button",
	buttons: "buttons",


persons: "persons",
person: "person",
firstname: "name",
lastname: "surname",
surname: "surname",
patronymic: "patronymic",
birth: "birth",
birthDate: "date of birth",
birthPlace: "place of birth",
death: "death",
deathDate: "date of death",
deathPlace: "place of death",
nationality: "nationality",
post: "post",
personsname: "person",
organization: "organization",

sex: "sex",
male: "male",
female: "female",

persons_roles: "person's roles",
claimant: "claimant",
owner: "owner",
holder: "holder",
driver: "driver",
previous_owners: "previous owners",

identification: "identification document",
seria: "seria",
issuedby: "issued by",
dateofissue: "date of issue",
recordno: "record No",
dateofexpiry: "date of expiry",
documentno: "document No",

dateOfIssue: "date of issue",
dateOfExpiry: "date of expiry",

image: "image",
images: "images",

identificationstype: "identification's type",
identificationstypes: "identification's types",
passport: "passport",
passportCitizen: "passport of the citizen",
passportForeign: "foreign passport",
passportDiplomatic: "diplomatic passport",
passportService: "service passport",
passportSeamen: "seamen's passport",
passportCrew: "crew member certificate",
passportReturn: "identity card for return",
passportTemporary: "temporary identity card",
driverLicense: "driver license",
identityCardTravel: "stateless identity card for travel abroad",
identityCardPermanent: "permanent residence permit",
identityCardTemporary: "temporary residence permit",
identityCardMigrant: "migrant card",
refugeeCertificate: "refugee certificate",
refugeeTravelDocument: "refugee travel document",
identityCardAdditionalProtection: "identity card in need of additional protection",
identityCardGrantedAdditionalProtection: "travel document of a person who has been granted additional protection",

addresses: "addresses",
address: "address",
postalCode: "postal сode",
сountry: "сountry",
region: "region",
district: "district",
locality: "locality",
street: "street",
house: "house",
home: "home",
apartment: "apartment",
flat: "flat",
latitude: "latitude",
longitude: "longitude",
trackNumber: "track number",
trackNumbers: "track numbers",
place: "place",
places: "places",
contact: "contact",
contacts: "contacts",

addressestypes: "addresses types",
addresstype: "address type",
addressResidence: "address of residence",
addressRegistration: "address of registration",

document: "document",
documents: "documents",
templates: "templates",
template: "template",
constructors: "constructors",
constructor: "constructor",

policies: "insurance contracts",
policy: "insurance contract",

periodValidity: "validity period",

notifications: "notifications",
notification: "notification",
vehicles: "vehicles",
vehicle: "vehicle",
vehicleNumber: "vehicle number",
configuration: "configuration",

dateEvent: "event date",
dateNotice: "notice date",
circumstance: "circumstance",
informant: "informant",
informing: "method of information",

cases: "cases",
case: "case",

payments: "payments",
payment: "payment",


calendars: "calendars",
calendar: "calendars",


	//-- Actions -------------------------
	download: "download",
	upload: "upload",

	filter: "filter",
	filters: "filters",

	history: "history",
	histories: "histories",

	requestContact: "request contact",
	requestLocation: "request location",

	InsuranceObject: "insurance object",
	InsuranceObjects: "insurance objects",
	InsuranceObjectType: "insurance object's type",
	InsuranceObjectTypes: "insurance object's types",
	InsuranceObjectProperty: "insurance object's property",
	InsuranceObjectProperties: "insurance object's properties",

	//---------------------------
	Account: "account",
	Accounts: "accounts",

	CommentType: "comment type",
	CommentTypes: "comment types",

	Court: "court",
	Courts: "courts",
	CourtCase: "court`s case",
	CourtCases: "court`s cases",
	CourtCaseAction: "court`s case action",
	CourtCaseActions: "court`s case actions",
	CourtCaseActionType: "court`s case action type",
	CourtCaseActionTypes: "court`s case action types",
	CourtCaseComment: "court`s case comment",
	CourtCaseComments: "court`s cases comments",
	CourtCaseFinance: "court`s case finance",
	CourtCaseFinances: "court`s case finances",
	CourtCaseFinanceType: "court`s case finance type",
	CourtCaseFinanceTypes: "court`s case finance types",
	CourtCaseHistory: "court`s case history",
	CourtCaseHistories: "court`s cases histories",
	CourtCaseInsuranceCase: "insurance case of court case",
	CourtCaseInsuranceCases: "insurance cases of court cases",
	CourtCaseInsuranceCaseType: "insurance case's type  of court case",
	CourtCaseInsuranceCaseTypes: "insurance case's types  of court cases",
	CourtCaseInsuranceContract: "insurance contract of court case",
	CourtCaseInsuranceContracts: "insurance contracts of court cases",
	CourtCaseInsuranceContractType: "insurance contract's type of court case",
	CourtCaseInsuranceContractTypes: "insurance contract's types of court cases",
	CourtCaseJudgment: "court`s case judgment",
	CourtCaseJudgments: "court`s case judgments",
	CourtCaseJudgmentType: "court`s case judgment type",
	CourtCaseJudgmentTypes: "court`s case judgment types",
	CourtCaseMedia: "court`s case document",
	CourtCaseMedias: "court`s cases documents",
	CourtCaseMediaType: "court`s case document type",
	CourtCaseMediaTypes: "court`s cases document types",
	CourtCaseMember: "court`s case member",
	CourtCaseMembers: "court`s cases members",
	CourtCaseMemberType: "court`s case member type",
	CourtCaseMemberTypes: "court`s cases member types",
	CourtCaseStageType: "court`s case stage",
	CourtCaseStageTypes: "court`s case stages",
	CourtCaseStatusType: "court`s case status",
	CourtCaseStatusTypes: "court`s case types",
	CourtCaseType: "court`s case type",
	CourtCaseTypes: "court`s case statuses",
	CourtFormType: "court`s form",
	CourtFormTypes: "court`s forms",
	CourtType: "court`s type",
	CourtTypes: "court`s types",
	CourtCaseDateBegin: "court`s case date begin",
	CourtCaseDateEnd: "court`s case date end",

	CurrencyType: "currency type",
	CurrencyTypes: "currency types",
	
	Dictionary: "dictionary",
	Dictionaries: "dictionaries",
	
	ImageObject: "image object",
	ImageObjects: "image objects",
	InsuranceCase: "insurance case",
	InsuranceCases: "insurance cases",
	InsuranceCaseComment: "insurance case comment",
	InsuranceCaseComments: "insurance case comments",
	InsuranceCaseFinance: "insurance case finance",
	InsuranceCaseFinances: "insurance case finances",
	InsuranceCaseFinanceType: "insurance case finance type",
	InsuranceCaseFinanceTypes: "insurance case finance types",
	InsuranceCaseInsuranceContract: "insurance contract of insurance case",
	InsuranceCaseInsuranceContracts: "insurance contracts of insurance case",
	InsuranceCaseInsuranceContractType: "insurance case's type of insurance case",
	InsuranceCaseInsuranceContractTypes: "insurance case's types of insurance case",
	InsuranceCaseHistory: "insurance case history",
	InsuranceCaseHistories: "insurance case histories",
	InsuranceCaseMedia: "insurance case document",
	InsuranceCaseMedias: "insurance cases documents",
	InsuranceCaseMediaType: "insurance case document type",
	InsuranceCaseMediaTypes: "insurance cases document types",
	InsuranceCaseMember: "insurance case member",
	InsuranceCaseMembers: "insurance case members",
	InsuranceCaseMemberType: "insurance case member type",
	InsuranceCaseMemberTypes: "insurance case member types",
	InsuranceCaseStatus: "insurance case status",
	InsuranceCaseStatuses: "insurance case statuses",
	InsuranceCaseStatusType: "insurance case status type",
	InsuranceCaseStatusTypes: "insurance case status types",
	InsuranceCaseType: "insurance case type",
	InsuranceCaseTypes: "insurance case types",

	InsuranceClaim: "insurance claim",
	InsuranceClaims: "insurance claims",
	InsuranceClaimStatus: "insurance claim status type",
	InsuranceClaimStatuses: "insurance claim status types",
	InsuranceClaimStatusType: "insurance claim status type",
	InsuranceClaimStatusTypes: "insurance claim status types",
	InsuranceClaimType: "insurance claim type",
	InsuranceClaimTypes: "insurance claim types",

	InsuranceContract: "insurance contract",
	InsuranceContracts: "insurance contracts",
	InsuranceContractComment: "insurance contract comment",
	InsuranceContractComments: "insurance contract comments",
	InsuranceContractFinance: "insurance contract finance",
	InsuranceContractFinances: "insurance contract finances",
	InsuranceContractFinanceType: "insurance contract finance type",
	InsuranceContractFinanceTypes: "insurance contract finance types",
	InsuranceContractHistory: "insurance contract history",
	InsuranceContractHistories: "insurance contract histories",
	InsuranceContractMedia: "insurance contract document",
	InsuranceContractMedias: "insurance contract documents",
	InsuranceContractMediaType: "insurance contract document type",
	InsuranceContractMediaTypes: "insurance contract document types",
	InsuranceContractMember: "insurance contract member",
	InsuranceContractMembers: "insurance contract members",
	InsuranceContractMemberType: "insurance contract member type",
	InsuranceContractMemberTypes: "insurance contract member types",
	InsuranceContractMessage: "insurance contract message",
	InsuranceContractMessages: "insurance contract messages",
	InsuranceContractObject: "insurance contract object",
	InsuranceContractObjects: "insurance contract objects",
	InsuranceContractObjectType: "insurance contract object type",
	InsuranceContractObjectTypes: "insurance contract object types",
	InsuranceContractStatusType: "insurance contract status type",
	InsuranceContractStatusTypes: "insurance contract status types",
	InsuranceContractType: "insurance contract type",
	InsuranceContractTypes: "insurance contract types",

	InsuranceEvent: "insurance event",
	InsuranceEvents: "insurance events",
	InsuranceEventInformingType: "insurance event status type",
	InsuranceEventInformingTypes: "insurance event status types",
	InsuranceEventStatus: "insurance event status",
	InsuranceEventStatuses: "insurance event statuses",
	InsuranceEventStatusType: "insurance event status type",
	InsuranceEventStatusTypes: "insurance event status types",
	InsuranceEventType: "insurance event type",
	InsuranceEventTypes: "insurance event types",

	Member: "member",
	Members: "members",
	MemberType: "member type",
	MemberTypes: "member types",

	Menu: "menu",
	Menus: "menu",
	Method: "method",
	Methods: "methods",
	MethodParam: "parameter",
	MethodParams: "parameters",
	MenuType: "menu type",
	MenuTypes: "menu types",

	Organization: "organization",
	Organizations: "organizations",
	OrganizationAddress: "organization address",
	OrganizationAddresses: "organization addresses",
	OrganizationAddressType: "organization address type",
	OrganizationAddressTypes: "organization address types",
	OrganizationContact: "organization contact",
	OrganizationContacts: "organization contacts",
	OrganizationContactType: "organization contact type",
	OrganizationContactTypes: "organization contact types",
	OrganizationDepartment: "organization department",
	OrganizationDepartments: "organization departments",
	OrganizationDepartmentType: "organization department type",
	OrganizationDepartmentTypes: "organization department types",
	OrganizationEmployee: "organization employee",
	OrganizationEmployees: "organization employees",
	OrganizationEmployeeType: "organization employee type",
	OrganizationEmployeeTypes: "organization employee types",
	OrganizationKindType: "organization kind type",
	OrganizationKindTypes: "organization kind types",
	OrganizationPost: "organization post",
	OrganizationPosts: "organization posts",
	OrganizationPostType: "organization post type",
	OrganizationPostTypes: "organization post types",
	OrganizationType: "organization type",
	OrganizationTypes: "organization types",

	Person: "person",
	Persons: "persons",
	PersonAddress: "person address",
	PersonAddresses: "person addresses",
	PersonAddressType: "person address type",
	PersonAddressTypes: "person address types",
	PersonContact: "person contact",
	PersonContacts: "person contacts",
	PersonContactType: "person contact type",
	PersonContactTypes: "person contact types",
	PersonGenderType: "person gender type",
	PersonGenderTypes: "person gender types",

	PersonIdentitycard: "person identity card",
	PersonIdentitycards: "person identity cards",
	PersonIdentitycardType: "person identity card's type",
	PersonIdentitycardTypes: "person identity card's types",
	PersonIdentitycardMedia: "person identity card's media",
	PersonIdentitycardMedias: "person identity card's media",
	PersonIdentitycardMediaType: "person identity cards media type",
	PersonIdentitycardMediaTypes: "person identity cards media types",

	Place: "place",
	Places: "places",
	PlaceAddress: "address",
	PlaceAddresses: "addresses",
	PlaceCountry: "country",
	PlaceCountries: "countries",
	PlaceDistrict: "district",
	PlaceDistricts: "districts",
	PlaceLocality: "locality",
	PlaceLocalities: "localities",
	PlaceLocalityType: "locality type",
	PlaceLocalityTypes: "locality types",
	PlaceStreetType: "street type",
	PlaceStreetTypes: "street types",
	PlaceRegion: "region",
	PlaceRegions: "regions",

	PointContact: "contact",
	PointContacts: "contacts",
	PointContactType: "contact type",
	PointContactTypes: "contact types",
	
	Profile: "profile",
	Profiles: "profiles",

	Role: "role",
	Roles: "roles",

	Scenarium: "scenarium",
	Scenariums: "scenariums",
	ScenariumRequest: "scenarium request",
	ScenariumRequests: "scenarium requests",
	ScenariumRequestButton: "scenarium request button",
	ScenariumRequestButtons: "scenarium request buttons",
	ScenariumRespond: "scenarium respond",
	ScenariumResponds: "scenarium responds",
	
	Talk: "talk",
	Talks: "talks",

	Vehicle: "vehicle",
	Vehicles: "vehicles",
	VehicleType: "vehicle type",
	VehicleTypes: "vehicle types",
	VehicleBrand: "brand",
	VehicleBrands: "brands",
	VehicleBrandModel: "model",
	VehicleBrandModels: "models",

	
	stage: "stage",
	stages: "stages",
	status: "status",
	statuses: "statuses",
	сontract: "сontract",
	сontracts: "сontracts",
	insuranceContract: "insurance contract",
	insuranceContracts: "insurance contracts",
	settlementCase: "settlement case",
	settlementCases: "settlement cases",
	comment: "comment",
	comments: "comments",
	member: "member",
	members: "members",
	finance: "finance",
	finances: "finances",
	judgment: "judgment",
	judgments: "judgments",
	subject: "subject",
	subjects: "subjects",
	paymentProbability: "payment probability",
	paymentProbabilities: "payment probabilities",
	reserve: "reserve",
	reserves: "reserves",
	amount: "amount",
	amounts: "amounts",
	currency: "currency",
	currencies: "currencies",

	//---------------------------
	insurer: "insurer",
	insurant: "insurant",
	beneficiary: "beneficiary",

	company: "company",
	inn: "inn",
	
	//Rules
	rule: {
		required: "Value is required and can't be empty",
		mustBeSelected: "must be selected from the list",
		lenless: "Name must be less than {0} characters",
		code: "Code must be less than {0} characters",
		personsname: "Person's name is not correct",
		email: "E-mail is not correct",
		phone: "Phone number is not correct (+380961112233)",
	},

	btn: {
		previous: 'previous',
		next: 'next',
		menu: 'menu',
		summary: 'summary',
	},
	
	noDataText: 'no data available',

	dataIterator: {
		loadingText: 'loading data...'
	},

	dataTable: {
		itemsPerPageText: ' ',
		ariaLabel: {
			sortNone: ' ',
			sortAscending: ' ',
			sortDescending: ' ',
			activateNone: ' ',
			activateAscending: ' ',
			activateDescending: ' ',
		},
		loadingText: 'Loading... Please wait',
	},

	dataFooter: {
		firstPage: ' ',
		prevPage: ' ',
		nextPage: ' ',
		lastPage: ' ',
		itemsPerPageAll: ' ',
		itemsPerPageText: ' ',
		pageText: ' ',
	},

	datePicker: { 
		prevMonthAriaLabel: ' ',
		nextMonthAriaLabel: ' ',
		header: ' ',
	},

	carousel: {
		prev: 'previous',
		next: 'next',
		ariaLabel: {
			delimiter: 'delimiter'
		}
	},

	pagination: {
		ariaLabel: {
			previous: 'previous',
			currentPage: 'currentPage',
			page: 'page',
			next: 'next',
			wrapper: 'wrapper',
			root: 'root',
		}
	},

	badge: 'badge',

	input: {
		clear: 'clear',
		prependAction: ' ',
		appendAction: ' ',
		otp: 'otp',
	},
}